<template>
    <gmap-cluster ref="clusterer" :averageCenter="true" :styles="styles" @click="zoomCluster">
        <slot></slot>
    </gmap-cluster>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import GmapCluster from '../../helpers/Clusterer';
import ClusterImage from '@/assets/markers/cluster/cluster.svg';

export default {
  inject: ['mapComponent'],
  components: {
    GmapCluster,
  },
  provide() {
    return {
      deviceClusterer: () => this.$refs.clusterer,
    };
  },
  computed: {
    google: gmapApi,
    styles() {
      return [{
        anchorText: [-10, -10],
        // anchorText: [-4, -4],
        textColor: 'black',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: '800',
        textSize: 22,
        url: ClusterImage,
        width: 63,
        height: 61,
      }];
    },
  },
  methods: {
    zoomCluster(cluster) {
      const clusterDiagonal = this.google.maps.geometry.spherical.computeDistanceBetween(
        cluster.getBounds().getNorthEast(),
        cluster.getBounds().getSouthWest(),
      );

      if (clusterDiagonal > 25) {
        cluster.markerClusterer_.setZoomOnClick(false);
        this.mapComponent().fitBounds(cluster.getBounds(), { top: 100, bottom: 50, left: 10, right: 10 });
      } else {
        cluster.markerClusterer_.setZoomOnClick(false);
        const clusteredDevices = cluster.getMarkers().map(marker => marker.device);
        this.$store.dispatch('showClusterList', clusteredDevices);
      }
    },
  },
  mounted() {
    this.mapComponent().$mapPromise.then((map) => {
      this.google.maps.event.addListener(map, 'idle', () => {
        this.$refs.clusterer.$clusterObject.repaint();
      });
    });
  },
};
</script>
